(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
var grid = document.querySelector('.masonry-gallery');
if (grid && window.Masonry && window.imagesLoaded) {
var msnry = new Masonry(grid, {
itemSelector: '.masonry-item',
percentPosition: true
});

imagesLoaded(grid).on('progress', function () {
  msnry.layout();
});

}
});

  } catch(e) { console.error(e); }
})();
})();
